/**
 * User: Keith
 * Date: 7/1/2015
 * Time: 4:40 PM
 */

define('app/views/reservation',['require','text!../../../views/reservation.html'],function (require) {
  var template = require("text!../../../views/reservation.html");

  return Backbone.View.extend({
    template: _.template(template),

    events: {
      "click .calendarDate": "onDateClick",
      "click .calendarPrev": "onNavClick",
      "click .calendarNext": "onNavClick",
      "click .guestSelect": "onSelectGuests"
      // "click #submitReserve": "onSubmitReserve"
    },

    initialize: function () {
      this.render();
      // Add click listener to body for detecting calendar clicks
      $("body").click(this.onReservationBodyClick);
    },

    render: function () {
      // Make dates today and tomorrow for reserve values
      var today = new Date();
      todayStr =
        this.pad(today.getMonth() + 1, 2) +
        "/" +
        this.pad(today.getDate(), 2) +
        "/" +
        today.getFullYear();
      var tomorrow = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 1,
        0,
        0,
        0
      );
      tomorrowStr =
        this.pad(tomorrow.getMonth() + 1, 2) +
        "/" +
        this.pad(tomorrow.getDate(), 2) +
        "/" +
        tomorrow.getFullYear();
      var data = {
        TODAY: todayStr,
        TODAYCALENDAR: this.makeCalendar(todayStr, "arrive").outerHTML,
        TOMORROW: tomorrowStr,
        TOMORROWCALENDAR: this.makeCalendar(tomorrowStr, "depart").outerHTML
      };

      this.$el.html(this.template(data));

      // Make calendar
      return this.$el;
    },

    // Make a calendar within the following id
    // MM/DD/YYYY
    // Returns the calendar as an element (use .outterHTML to get htmlstr)
    makeCalendar: function (incomingDate, title) {
      var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      incomingDate = incomingDate.split("/");

      // Get dates
      var date = new Date(incomingDate[2], incomingDate[0] - 1, 1, 0, 0, 0);
      var month = date.getMonth();
      var year = date.getFullYear();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      var calendar = document.createElement("div");
      calendar.setAttribute("class", "calendar");
      var calendarWrap = document.createElement("div");
      calendarWrap.setAttribute("class", "calendarWrap");

      // Make title
      var titleDiv = document.createElement("div");
      titleDiv.setAttribute("class", "calendarName");
      titleDiv.innerHTML = "<h4>" + title + "</h4>";
      calendarWrap.appendChild(titleDiv);

      // Previous arrow cannot go before today
      var today = new Date();
      var todayMonthFirst = new Date(today.getFullYear(), today.getMonth(), 1);
      if (todayMonthFirst < firstDay) {
        // Previous arrow
        var prev = document.createElement("div");
        prev.setAttribute("class", "calendarPrev");
        prev.innerHTML = "&lt;";

        // Make first day of last month
        var lastMonthDay = new Date(year, month, 1, 0, 0, 0);
        prev.setAttribute(
          "data-date",
          this.pad(lastMonthDay.getMonth(), 2) +
            "/" +
            this.pad(lastMonthDay.getDate(), 2) +
            "/" +
            lastMonthDay.getFullYear()
        );

        calendar.appendChild(prev);
      } else {
        var empty = document.createElement("div");
        empty.setAttribute("class", "calendarEmpty");
        calendar.appendChild(empty);
      }

      // Create Month Title
      var title = document.createElement("div");
      title.innerHTML = monthNames[month] + " " + year;
      title.setAttribute("class", "calendarTitle");
      calendar.appendChild(title);

      // Next arrow
      var next = document.createElement("div");
      next.setAttribute("class", "calendarNext");
      next.innerHTML = "&gt;";
      // Make first day of next month
      var nextMonthDay = new Date(year, month + 2, 1, 0, 0, 0);
      next.setAttribute(
        "data-date",
        this.pad(nextMonthDay.getMonth(), 2) +
          "/" +
          this.pad(nextMonthDay.getDate(), 2) +
          "/" +
          nextMonthDay.getFullYear()
      );
      calendar.appendChild(next);

      // Create Day Titles
      var days = ["S", "M", "T", "W", "Th", "F", "Sa"];
      for (var i = 0; i < days.length; i++) {
        var dt = document.createElement("div");
        dt.setAttribute("class", "calendarDays");
        dt.innerHTML = days[i];
        calendar.appendChild(dt);
      }
      // Fill in emptys up to first day
      for (var i = 0; i < firstDay.getDay(); i++) {
        var empty = document.createElement("div");
        empty.setAttribute("class", "calendarEmpty");
        calendar.appendChild(empty);
      }
      // Create day numbers
      for (var i = firstDay.getDate(); i <= lastDay.getDate(); i++) {
        var today = new Date();
        var todayZero = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
          0,
          0,
          0
        );

        if (todayZero > new Date(year, month, i, 0, 0, 0)) {
          var date = document.createElement("div");
          date.setAttribute("class", "calendarDatePast");
          date.innerHTML = i;
        } else {
          var date = document.createElement("div");
          // If date is selected
          if (i == incomingDate[1]) {
            date.setAttribute("class", "calendarDate selected");
          } else {
            date.setAttribute("class", "calendarDate");
          }

          date.setAttribute(
            "data-date",
            this.pad(month + 1, 2) + "/" + this.pad(i, 2) + "/" + year
          );
          var link = document.createElement("a");
          link.setAttribute("class", "calendarLink");
          link.setAttribute(
            "data-date",
            this.pad(month + 1, 2) + "/" + this.pad(i, 2) + "/" + year
          );
          link.innerHTML = i;
          date.appendChild(link);
        }
        calendar.appendChild(date);
      }

      calendarWrap.appendChild(calendar);

      return calendarWrap;
    },

    onDateClick: function (e) {
      var target = $(e.target);
      var value = target.attr("data-date");
      var title = target.closest(".datepicker").attr("data-name");

      // Update input with this value
      target.closest(".datepicker").find(".dateInput").val(value);

      // Do some error checking
      var arrivalDate = this.parseDate($(".arrival").find(".dateInput").val());
      var departDate = this.parseDate($(".departure").find(".dateInput").val());
      var today = new Date();
      var todayZero = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        0,
        0,
        0
      );

      if (arrivalDate < todayZero) {
        //alert("You must select a date in the future.")
        // Set to today
        $(".arrival").find(".dateInput").val(this.makeDateStr(todayZero));
      } else if (departDate < todayZero) {
        /*alert("You must select a date in the future.")
			 // Set to arrival+1
			 /*var arrivalPlus = new Date(arrivalDate.getFullYear(), arrivalDate.getMonth(), arrivalDate.getDate()+1, 0, 0, 0);
			 $(".departure").find(".dateInput").val(this.makeDateStr(arrivalPlus));*/
      } else if (arrivalDate >= departDate) {
        // Make sure arrival > depart
        // Alert message if they're trying to set depart before arrival date
        if (target.closest(".datepicker").hasClass("departure")) {
          //alert("Your depart date must be set after your arrival date.");
        }
        // Set depart date +1 day ahead
        var newDepart = new Date(
          arrivalDate.getFullYear(),
          arrivalDate.getMonth(),
          arrivalDate.getDate() + 1,
          0,
          0,
          0
        );
        var newDepartStr = this.makeDateStr(newDepart);
        $(".departure").find(".dateInput").val(newDepartStr);

        // Make new departure calendar
        $(".departure")
          .find(".reserveCalendar")
          .html(this.makeCalendar(newDepartStr, "depart"));
      } else {
        console.log("Replacing Cal");
        // Replace calendar with new calendar
        var value = target.closest(".datepicker").find(".dateInput").val();
        var title = target.closest(".datepicker").attr("data-name");
        target
          .closest(".datepicker")
          .find(".reserveCalendar")
          .html(this.makeCalendar(value, title));
      }
      // If this is arrival, move to depart
      if (title == "arrive") {
        // Move to depart
        $("#departInput").click();
      }

      // If depart, move to guests
      if (title == "depart") {
        $("#guestsInput").click();
      }
    },

    onNavClick: function (e) {
      var target = $(e.target);
      var value = target.attr("data-date");
      var title = target.closest(".datepicker").attr("data-name");
      // Get calendar
      var calendar = this.makeCalendar(value, title);

      // Replace calendar
      target.closest(".datepicker").find(".reserveCalendar").html(calendar);
    },

    onReservationBodyClick: function (e) {
      var target = $(e.target);
      $(".dateInput").mask("99/99/9999");

      if (
        target.attr("class") != "calendarPrev" &&
        target.attr("class") != "calendarNext" &&
        target.attr("class") != "calendarDate" &&
        target.attr("class") != "calendarLink"
      ) {
        if (target.parents(".datepicker").length > 0) {
          // Hide other calendars
          target
            .parent(".datepicker")
            .siblings(".datepicker")
            .each(function (i, element) {
              $(element).find(".reserveCalendar").hide(300);
              // Remove bold
              $(element).removeClass("active");
            });
          // Show the calendar
          target.parent(".datepicker").find(".reserveCalendar").slideDown(300);
          // Add bold
          target.parent(".datepicker").addClass("active");
        } else {
          // Hide all calendars
          $(".reserveCalendar").slideUp(200);
          // Remove all bold
          $(".datepickers")
            .find(".active")
            .each(function (i, element) {
              $(element).removeClass("active");
            });
        }
      }
    },

    onSelectGuests: function (e) {
      $(".guestSelected").removeClass("guestSelected");
      var target = $(e.target);
      var guests = target.html();

      $("#guestsInput").val(guests);

      target.addClass("guestSelected");
    },

    // onSubmitReserve: function () {
    //   var arrive = new Date($("#arriveInput").val());
    //   var depart = new Date($("#departInput").val());

    //   var diffTime = Math.abs(depart - arrive);
    //   var lengthOfStay = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    //   var formattedArrive =
    //     arrive.getFullYear() +
    //     "-" +
    //     (arrive.getMonth() + 1) +
    //     "-" +
    //     arrive.getDate();

    //   var guests = $("#guestsInput").val();

    //   var bookingURL =
    //     "https://loft523.book.pegsbe.com/rooms?" +
    //     "&CheckinDate=" +
    //     formattedArrive +
    //     "&LOS=" +
    //     lengthOfStay +
    //     "&Adults_1=" +
    //     guests;

    //   // Open link
    //   var win = window.open(bookingURL, "_blank");
    //   win.focus();
    // },

    pad: function (num, size) {
      var s = "000000000" + num;
      return s.substr(s.length - size);
    },

    // MM/DD/YYYY
    parseDate: function (dateStr) {
      var dateStr = dateStr.split("/");

      return new Date(
        dateStr[2],
        parseInt(dateStr[0]) - 1,
        dateStr[1],
        0,
        0,
        0
      );
    },

    makeDateStr: function (dateValue) {
      return (
        this.pad(dateValue.getMonth() + 1, 2) +
        "/" +
        this.pad(dateValue.getDate(), 2) +
        "/" +
        dateValue.getFullYear()
      );
    }
  });
});

